module.exports = __webpack_public_path__ + "static/media/JV.4a726b2c.jpg";